import { useLingui } from "@lingui/react/macro";
import { Anchor, Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DocHeading } from "@/components/docs/DocHeading.tsx";
import { DocImage } from "@/components/docs/DocImage.tsx";
import { DocsContent } from "@/components/docs/DocsContent.tsx";
import overviewEn from "@/docs/images/property-search/property-search-overview.en.webp";
import overviewSv from "@/docs/images/property-search/property-search-overview.sv.webp";

export const Route = createFileRoute("/docs/property-search/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useLingui();

  return (
    <DocsContent>
      <Title order={1} size="h2">{t`What is property search?`}</Title>
      <Text>
        <Anchor href="/property/search">{t`Property Search`}</Anchor>
        {t` lets you search for properties,
        inspect relevant information and export or download the results in different formats. The process consists of two
        steps: `}
        <Anchor href="/docs/property-search/select-properties">{t`Select properties`}</Anchor>
        {t` and `}
        <Anchor href="/docs/property-search/specify-data-extract">{t`Specify data extract`}</Anchor>
        .{" "}
        {t` You navigate between these steps clicking on the stepper steps on the top of the page or by using the navigation buttons in the bottom.`}
      </Text>

      <DocImage
        src={{ sv: overviewSv, en: overviewEn }}
        alt={t`Property search overview`}
      />

      <DocHeading
        order={2}
        size="h3"
      >{t`Dataset and included information`}</DocHeading>
      <Text>
        {t`The exact information shown depends on the permissions on user and project level, the chosen datasets and the data available from Lantmäteriet for the property.`}
        {t`Read more about what type of data that is included on the page `}
        <Anchor href="/docs/property-search/viewing-property-information">
          {t`Viewing property information`}
        </Anchor>
      </Text>

      <DocHeading order={2} size="h3">{t`Data source`}</DocHeading>
      <Text>
        {t`Property Search retrieves information from Lantmäteriet's direct access services (API and web services).`}
      </Text>
    </DocsContent>
  );
}
